import { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"

export default function GreatSpinsOfFortune() {
  const data = promotionsData.find(
    (promo) => promo.title === "TPGreat Spins of Fortune"
  )
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>TPGreat Spins of Fortune</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/"> Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>{data.title}</h1>
                <h2>
                  Win up to ₱2,500 FREE Credits Weekly this Chinese New Year!
                </h2>
                <div className="promotion-tnc-period">
                  <strong>Event Period:</strong>
                  <span> February 17, 2026 - March 17, 2026</span>
                  <br />
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <strong> Terms & Conditions </strong>
                <ol>
                  <li>
                    {" "}
                    This promotion is open to FGH players who play the selected
                    TPG games.
                  </li>
                  <li>
                    {" "}
                    A minimum turnover of 5,000 is required to qualify for the
                    draw.{" "}
                  </li>
                  <li>
                    {" "}
                    There will be 12 lucky winners, each receiving prizes of up
                    to ₱2,500 Free Credits, with no rollover requirement.{" "}
                  </li>
                  <li>
                    {" "}
                    Weekly cutoff: Tuesday 12:00NN to the following Tuesday
                    11:59AM.{" "}
                  </li>
                  <li>
                    {" "}
                    Announcement and Awarding of winners will take place every
                    Tuesday at 3:00PM.{" "}
                  </li>
                  <li>
                    {" "}
                    FGH reserves the right to amend, extend, or terminate this
                    promotion at any time without prior notice.{" "}
                  </li>
                </ol>
                <div className="table-wrapper">
                  <table
                    className="promotion-tnc-table"
                    style={{ minWidth: "0" }}
                  >
                    <thead>
                      <th> Weekly Winners </th>
                      <th> Free Credits </th>
                      <th> Rollover </th>
                    </thead>
                    <tbody>
                      <tr>
                        <td> 2 </td>
                        <td> 2,500.00 </td>
                        <td> </td>
                      </tr>
                      <tr>
                        <td> 5 </td>
                        <td> 750.00 </td>
                        <td> No Rollover </td>
                      </tr>
                      <tr>
                        <td> 5 </td>
                        <td> 250.00 </td>
                        <td> </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
